module.exports = __webpack_public_path__ + "img/1.af1f3c1c.jpg";